<template>
    <div class="body">
         <header class="header-section">
            <h1 class="main-title">💡创新思维</h1>
            <h1 class="main-title">打破无形的高墙</h1>
            <div class="subtitle-wrapper">
                <span class="subtitle-badge">破局</span>
                <span class="subtitle-badge">联结</span>
                <span class="subtitle-badge">重构</span>
            </div>
        </header>

        <section class="quote-card">
            <p class="p-highlight">所敢于提出的每一个质疑， </p>
            <div class="p-content">
                <p>都在催生前所未有的可能。</p>
            </div>
            <div class="p-content">
                <p>灵感背后，是不被既定经验束缚的勇气。 </p>
            </div>
        </section>

        <div class="wrapper">
            <div class="course-section">
                <!-- <h3 class="section-title">
                    <i class="icon-fire">🔥</i> 2025年11月热门课程
                </h3> -->
                <div class="course-grid">
                    <label v-for="(item, index) in proRecommend" :key="'hot-' + index" 
                           :class="['course-item', { 'is-active': selectedCourses.includes(item.Name) }]">
                        <input type="checkbox" :value="item.Name" v-model="selectedCourses" />
                        <span class="check-mark"></span>
                        <span class="course-name">{{ item.Name }}</span>
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        ReportData: { type: Object, required: false },
        selected: { type: Array, default: () => [] }
    },
    data() {
        return {
            proRecommend:[],
            selectedCourses: []
        }
    },
    created() {
        if (this.ReportData) {
            this.proRecommend = JSON.parse(this.ReportData.proRecommend || '[]');
        }
    },
    watch: {
        selectedCourses: {
            deep: true,
            handler(newVal) {
                this.$emit('update:selected', newVal);
            }
        }
    },
    mounted() {
        this.selectedCourses = [...this.selected];
    }
}
</script>

<style scoped>
/* 年度报告风格 · 深色选课页通用主题（蓝调） */
:root {
    --ar-gold: #4a9eff;
}

.body {
    position: relative;
    background:
        url("../../assets/26June/logo.png") right top no-repeat,
        url("../../assets/26September/bg.png") no-repeat center / cover;
    background-size: 100px 32px, cover;
    background-color: #1a0810;
	width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    color: #2d1505;
    box-sizing: border-box;
    padding: 20px 0;
    text-shadow: 0 0 3px rgba(255, 240, 210, 0.5), 0 1px 2px rgba(255, 240, 210, 0.3);
}

.body * {
    text-shadow: 0 0 3px rgba(255, 240, 210, 0.5), 0 1px 2px rgba(255, 240, 210, 0.3);
}

/* 头部 */
.header-section {
  position: relative;
  z-index: 2;
  padding-top: 5vh;
  text-align: center;
  margin-bottom: 16px;
}
.main-title {
  font-size: 25px;
  color: #4a9eff;
  margin: 0;
  font-weight: 800;
  letter-spacing: 2px;
}
/* .main-title:first-child {
  background: linear-gradient(180deg, #7cc8ff, #4a9eff 60%, #2d7dd6);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.6));
  margin-bottom: 4px;
} */
.subtitle-wrapper {
  margin-top: 10px;
  display: flex;
  gap: 10px;
  justify-content: center;
}
.subtitle-badge {
  font-size: 14px;
  background: rgba(74, 158, 255, 0.1);
  border: 1px solid rgba(74, 158, 255, 0.35);
  color: #121313;
  padding: 3px 12px;
  border-radius: 20px;
  letter-spacing: 1px;
}

/* 引用卡片 */
.quote-card {
  position: relative;
  z-index: 2;
  width: 80%;
  background: rgba(255, 245, 230, 0.15);
  border: 1px solid rgba(80, 40, 15, 0.2);
  border-left: 3px solid #4a9eff;
  padding: 14px 16px;
  margin-bottom: 18px;
  border-radius: 14px;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.25), inset 0 1px 0 rgba(255, 255, 255, 0.06);
}
.p-highlight {
  font-weight: 700;
  color: #379de7;
  margin: 0 0 5px 0;
  font-size: 15px;
  letter-spacing: 1px;
}
.p-content {
  font-size: 13.5px;
  color: rgba(45, 20, 5, 0.85);
  line-height: 1.5;
}

/* 课程列表 */
.wrapper {
    position: relative;
    z-index: 2;
    width: 84%;
    margin: 0 auto;
}

.course-section {
    background: transparent;
    border-radius: 16px;
}

/* 课程项 */
.course-grid {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.course-item {
    display: flex;
    align-items: center;
    padding: 15px 16px;
    background: rgba(255, 245, 230, 0.15);
    border: 1.5px solid rgba(80, 40, 15, 0.2);
    border-radius: 14px;
    transition: all 0.3s ease;
    cursor: pointer;
    position: relative;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.05);
}

.course-item input {
    position: absolute;
    opacity: 0;
}

.check-mark {
    width: 20px;
    height: 20px;
    border: 2px solid rgba(14, 14, 14, 0.3);
    border-radius: 50%;
    margin-right: 12px;
    position: relative;
    transition: all 0.3s;
    flex-shrink: 0;
}

.course-item:active {
    transform: scale(0.97);
}

.course-item.is-active {
    border-color: rgba(74, 158, 255, 0.75);
    background: rgba(74, 158, 255, 0.1);
    box-shadow: 0 8px 24px rgba(74, 158, 255, 0.16), inset 0 1px 0 rgba(255, 255, 255, 0.08);
}

.course-item.is-active .check-mark {
    background: linear-gradient(135deg, #a8d8ff, #2d7dd6);
    border-color: #4a9eff;
    box-shadow: 0 0 10px rgba(74, 158, 255, 0.6);
}

.course-item.is-active .check-mark::after {
    content: '✓';
    color: #ffffff;
    font-weight: 900;
    position: absolute;
    left: 3px;
    top: -2px;
    font-size: 14px;
}

.course-name {
    font-size: 15px;
    font-weight: 500;
    color: rgba(45, 20, 5, 0.85);
    letter-spacing: 0.5px;
}

/* 打钩动画 */
.course-item.is-active .check-mark::after {
    animation: popIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes popIn {
    0% { transform: scale(0); }
    100% { transform: scale(1); }
}

/* PC 端适配 */
@media screen and (min-width: 786px) {
    .body {
        background:
            url("../../assets/26June/logo.png") right top no-repeat,
            url("../../assets/26September/pcbg.png") no-repeat center / cover;
        background-size: 110px 35px, cover;
        width: 100% !important;
        height: 100vh !important;
        padding: 60px 10%;
        border-radius: 0 !important;
        box-shadow: none !important;
        border: none !important;
    }
    .main-title {
        font-size: 32px;
    }
    .subtitle-badge {
        font-size: 20px;
    }
    .course-name {
        font-size: 20px;
    }
    .p-highlight {
        font-size: 24px;
        font-weight: 700;
        color: #095b96;
    }
    .p-content {
        font-size: 24px;
        color: rgba(45, 20, 5, 0.85);
    }
    .quote-card, .wrapper {
        width: 600px;
    }
    .course-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 15px;
    }
}
</style>